import React from "react"

const Item = ({ title, des, image, amazon, rakuten }) => (
  <div className="poppotennis-media">
    <div className="poppotennis-media__imgpart">
      <a target="_blank" rel="noopener noreferrer" href={amazon}>
        <img
          alt=""
          src={image}
          width="160"
          height="160"
          loading="lazy"
          className="poppotennis-media__shadow"
        />
      </a>
    </div>
    <div className="poppotennis-media__infopart">
      <div className="poppotennis-media__title">
        <a target="_blank" rel="noopener noreferrer" href={amazon}>
          {title}
        </a>
      </div>
      <div className="poppotennis-media__description">{des}</div>
      <div className="poppotennis-media__btns __two">
        <div>
          <a
            className="poppotennis-media__btn __orange"
            target="_blank"
            rel="noopener noreferrer"
            href={amazon}
          >
            Amazon
          </a>
        </div>
        {rakuten ? (
          <div>
            <a
              className="poppotennis-media__btn __red"
              target="_blank"
              rel="noopener noreferrer"
              href={rakuten}
            >
              楽天
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  </div>
)

export default Item
